import { Injectable } from '@angular/core';
import { Base } from "./base";
import { UnitsCustomService } from '../../_services';
import { Property as T, ParkingSpace } from '../Interfaces';

@Injectable()
export class Property extends Base implements T {
    property_id: number;
    name: string;
    parking_area: string;
    parking_spaces: ParkingSpace[];
    constructor(json?: T) {
        super(json);
    }
    get id() {
        return this.property_id;
    }
    toString(): string {
        return this.name;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/property.ts